'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPortal = require('react-portal');

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _elementClass = require('element-class');

var _elementClass2 = _interopRequireDefault(_elementClass);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTest = process.env.NODE_ENV === 'test';

var ModalContainer = function (_Component) {
    (0, _inherits3.default)(ModalContainer, _Component);

    function ModalContainer(props) {
        (0, _classCallCheck3.default)(this, ModalContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalContainer.__proto__ || (0, _getPrototypeOf2.default)(ModalContainer)).call(this, props));

        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.openModal = _this.openModal.bind(_this);
        _this.endCloseAnimation = _this.endCloseAnimation.bind(_this);
        _this.timeouts = [];
        _this.state = {
            modalOpened: false,
            animation: null
        };
        return _this;
    }

    (0, _createClass3.default)(ModalContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isOpen && !this.state.modalOpened) {
                this.openModal();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isOpen && !this.state.modalOpened) {
                this.openModal();
            } else if (!nextProps.isOpen && this.state.modalOpened) {
                this.closeModal();
            };
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
            var _props = this.props,
                theme = _props.theme,
                appendToBody = _props.appendToBody;

            if (theme && appendToBody) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);
            }
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            var _this2 = this;

            var _props2 = this.props,
                closeOnEsc = _props2.closeOnEsc,
                theme = _props2.theme,
                appendToBody = _props2.appendToBody,
                animates = _props2.animates,
                onOpen = _props2.onOpen;


            if (closeOnEsc) {
                document.addEventListener('keydown', this.handleKeydown);
            }

            if (theme && appendToBody) {
                (0, _elementClass2.default)(document.body).add(theme.stopBodyScroll);
            }

            if (onOpen) {
                onOpen();
            }

            if (animates) {
                this.setState({
                    modalOpened: true
                }, function () {
                    _this2.timeouts.push(setTimeout(function () {
                        return _this2.setState({ animation: "opening" });
                    }, 10));
                });
            } else {
                this.setState({
                    modalOpened: true
                });
            }
        }
    }, {
        key: 'endCloseAnimation',
        value: function endCloseAnimation() {
            this.setState({ modalOpened: false, animation: null });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            var _this3 = this;

            var _props3 = this.props,
                closeOnEsc = _props3.closeOnEsc,
                theme = _props3.theme,
                appendToBody = _props3.appendToBody,
                animates = _props3.animates;

            if (closeOnEsc) {
                document.removeEventListener('keydown', this.handleKeydown);
            }

            if (theme && appendToBody) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);
            }

            if (animates && this.state.modalOpened) {
                this.setState({
                    animation: "closing"
                }, function () {
                    _this3.timeouts.push(setTimeout(_this3.endCloseAnimation, 300));
                });
            } else {
                this.setState({
                    modalOpened: false
                });
            }
        }
    }, {
        key: 'handleKeydown',
        value: function handleKeydown(e) {
            switch (e.key) {
                case "Escape":
                    if (this.props.closeOnEsc) {
                        this.props.onClose();
                    };
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'handleOutsideClick',
        value: function handleOutsideClick() {
            var _props4 = this.props,
                closeOnOutsideClick = _props4.closeOnOutsideClick,
                onClose = _props4.onClose;

            if (closeOnOutsideClick) {
                onClose();
            }
        }
    }, {
        key: 'handleInsideClick',
        value: function handleInsideClick(e) {
            e.stopPropagation();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props5 = this.props,
                onClose = _props5.onClose,
                animates = _props5.animates,
                overlayClass = _props5.overlayClass,
                modalClass = _props5.modalClass,
                children = _props5.children,
                dataTn = _props5.dataTn,
                modalPosition = _props5.modalPosition,
                modalSize = _props5.modalSize,
                theme = _props5.theme,
                appendToBody = _props5.appendToBody;
            var _state = this.state,
                modalOpened = _state.modalOpened,
                animation = _state.animation;


            if (!theme) {
                return null;
            }

            var overlayClasses = (0, _classnames4.default)(theme.overlayDefault, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.overlayFadeStart, animates), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultOpening, animates && animation === "opening"), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultClosing, animates && animation === "closing"), _classnames), overlayClass);

            var modalClasses = (0, _classnames4.default)(theme.modalDefault, (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, theme.modalMedium, modalSize === 'medium'), (0, _defineProperty3.default)(_classnames2, theme.modalLarge, modalSize === 'large'), (0, _defineProperty3.default)(_classnames2, theme.modalHeightCenter, modalPosition === 'center'), _classnames2), modalClass);

            var modal = _react2.default.createElement(
                'div',
                { onClick: this.handleOutsideClick, id: 'ModalOverlay', className: overlayClasses },
                _react2.default.createElement(
                    'div',
                    {
                        id: 'Modal',
                        onClick: this.handleInsideClick,
                        className: modalClasses,
                        'data-tn': dataTn
                    },
                    children
                )
            );
            if (appendToBody) {
                return _react2.default.createElement(
                    _reactPortal2.default,
                    {
                        isOpened: modalOpened,
                        onClose: onClose,
                        closeOnOutsideClick: false,
                        closeOnEsc: false
                    },
                    modal
                );
            }

            return modal;
        }
    }]);
    return ModalContainer;
}(_react.Component);

ModalContainer.defaultProps = {
    animates: true,
    closeOnEsc: true,
    closeOnOutsideClick: true,
    modalPosition: 'top',
    modalSize: 'default',
    appendToBody: isTest ? false : true
};
;

exports.default = ModalContainer;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/ModalContainer/index.js
// module id = 858
// module chunks = 4 5 8 9 14